<script>
import { mapGetters } from 'vuex'
import Global from '@/modules/mixins/global'
import Swipe from '@/modules/mixins/swipe'
export default {
    name: 'Banners',
    components: {},
    mixins: [Global, Swipe],
    data() {
        return {
            loaded: false,
            bannerCountByView: 3,
            containerWidth: 0,
            index: 0,
        }
    },
    computed: {
        ...mapGetters({
            list: 'banners/list',
            model: 'banners/model',
        }),
        items() {
            return this.sortNull(this.list)
        },
        hasBanners() {
            return this.list?.length && !this.isLandingPage
        },
        isLandingPage() {
            return !!this.$route.query.bannerId
        },
        width() {
            return (this.list.length * 100) / this.bannerCountByView
        },
        xPosition() {
            const currentIndexPosition = `-${(100 / this.bannerCountByView) * this.index}%`

            if (this.isTouch) {
                return `calc(${currentIndexPosition} + ${this.currentXDiff}px)`
            }

            return currentIndexPosition
        },
        hasPrev() {
            return this.index > 0
        },
        hasNext() {
            return this.index + this.bannerCountByView < this.list.length
        },
    },
    watch: {
        $route() {
            this.$nextTick(() => {
                this.onResize()
            })
        },
    },
    async created() {
        try {
            await this.$store.dispatch('banners/fetch')
        } finally {
            this.loaded = true
            this.onResize()
        }
    },
    async mounted() {
        window.addEventListener('resize', this.onResize)
        this.onResize()
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        hasLink(banner) {
            return (
                banner.type === 'restaurant_page' ||
                banner.type === 'restaurant_list' ||
                (banner.type === 'custom' && banner.link)
            )
        },
        prev() {
            if (!this.hasPrev) {
                return
            }
            this.index--
        },
        next() {
            if (!this.hasNext) {
                return
            }
            this.index++
        },
        onResize() {
            this.bannerCountByView = 3

            if (window.innerWidth < 1600) {
                this.bannerCountByView = 2
            }

            if (window.innerWidth < 1200) {
                this.bannerCountByView = 1
            }
            this.containerWidth = this.$refs.container?.clientWidth

            if (this.index + this.bannerCountByView > this.list.length) {
                this.prev()
            }
        },
        onSwipeEnd(swipedLength) {
            let desiredSwipeLengthForPaging = this.containerWidth / 4

            if (Math.abs(swipedLength) < desiredSwipeLengthForPaging) {
                return
            }

            if (swipedLength > 0) {
                this.prev()
            } else {
                this.next()
            }
        },
        openLink(banner) {
            if (banner.type === 'custom' && banner.link) {
                window.open(banner.link, '_blank')
                return
            }
            if (banner.type === 'restaurant_page') {
                this.$router.push({
                    name: 'restaurant',
                    params: {
                        slug: banner.landingPage.restaurants[0].slug,
                    },
                    query: {
                        bannerId: banner.id,
                    },
                })
                return
            }
            if (banner.type === 'restaurant_list') {
                this.$router.push({
                    query: {
                        bannerId: banner.id,
                    },
                })
                return
            }
        },
    },
}
</script>

<template lang="pug">
.banner-carousel(v-if="hasBanners" ref="container" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd")
    .banner-carousel-clip
        .banner-carousel-padding
            table(:style="`width:${this.width}%; margin-left:${this.xPosition}`" :class="{animated: !isTouch}")
                td(v-for="(banner, index) in items" :key="`banner-${index}`")
                    .banner-holder
                        .banner(
                            @click="openLink(banner)"
                            :class="{'cursor-pointer' : hasLink(banner)}"
                            :style="`background-color:${banner.banner.bg_color}; color:${banner.banner.text_color}`")
                            .banner-content
                                .banner-text
                                    .banner-title.font-weight-bolder {{ banner.banner.title }}
                                    .banner-description.font-size-xs {{ banner.banner.description }}
                                .banner-button.font-weight-bolder(v-if="banner.banner.button.text" :style="`background-color:${banner.banner.button.bg_color}; color:${banner.banner.button.text_color}`") {{ banner.banner.button.text }}
                            .banner-image(v-if="banner.banner.image" :style="`background-image:url(${banner.banner.image})`")
    .navigation
        .btn.step-prev(v-if="hasPrev" @click="prev")
            icon(icon="fa-solid fa-angle-left")
        .btn.step-next(v-if="hasNext" @click="next")
            icon(icon="fa-solid fa-angle-right")

</template>
